import React from "react";
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function About() {
  const { t } = useTranslation();

  return (
    <div>
      {/* ── Hero ──────────────────────────────────────────────────────────── */}
      <section
        style={{
          backgroundColor: "#f7f5ff",
          padding: "72px 20px 56px",
          borderBottom: "1px solid #ede9ff",
        }}
      >
        <Container className="text-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <img
              src="/img/portrait-jo.jpg"
              alt={t("about.portrait_alt")}
              className="rounded-circle mb-4"
              style={{
                width: 110,
                height: 110,
                objectFit: "cover",
                border: "4px solid white",
                boxShadow: "0 4px 24px rgba(106,17,203,0.12)",
              }}
            />
            <h1 className="fw-bold mb-1" style={{ fontSize: "1.9rem", color: "#1a1a2e" }}>
              {t("about.title")}
            </h1>
            <p className="text-secondary mb-0" style={{ fontSize: "0.95rem" }}>
              {t("about.signature")}
            </p>
          </motion.div>
        </Container>
      </section>

      {/* ── Content ───────────────────────────────────────────────────────── */}
      <section style={{ backgroundColor: "#ffffff", padding: "64px 20px 80px" }}>
        <Container style={{ maxWidth: 660 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
          >

            {/* Section 1 — My Story */}
            <div className="mb-5">
              <SectionLabel>{t("about.section1_title")}</SectionLabel>
              <p className="mb-4" style={prose}>{t("about.story_part1")}</p>
              <p style={prose}>{t("about.story_part2")}</p>
            </div>

            <hr style={{ border: "none", borderTop: "1px solid #ede9ff", margin: "2.5rem 0" }} />

            {/* Section 2 — How it Started */}
            <div>
              <SectionLabel>{t("about.section2_title")}</SectionLabel>
              <p className="mb-4" style={prose}>{t("about.story_part3")}</p>
              <p className="mb-4" style={prose}>{t("about.story_part4")}</p>
              <p style={prose}>{t("about.story_part5")}</p>

              {/* Pull-quote */}
              <blockquote
                style={{
                  borderLeft: "3px solid #6a11cb",
                  paddingLeft: "1.25rem",
                  margin: "2.5rem 0 2rem",
                }}
              >
                <p className="fw-semibold mb-1" style={{ fontSize: "1.05rem", color: "#444" }}>
                  {t("about.story_part6")}
                </p>
                <p className="fw-bold mb-0" style={{ fontSize: "1.4rem", color: "#1a1a2e" }}>
                  {t("about.story_part7")}
                </p>
              </blockquote>

              {/* Signature */}
              <p
                className="fst-italic text-end"
                style={{ color: "#888", fontSize: "0.9rem", marginTop: "3rem" }}
              >
                — {t("about.signature")}
              </p>
            </div>

          </motion.div>
        </Container>
      </section>
    </div>
  );
}

// ── Helpers ────────────────────────────────────────────────────────────────────
function SectionLabel({ children }) {
  return (
    <div className="d-flex align-items-center gap-2 mb-4">
      <div
        style={{
          width: 3,
          height: 18,
          backgroundColor: "#6a11cb",
          borderRadius: 2,
          flexShrink: 0,
        }}
      />
      <span
        className="fw-semibold text-secondary"
        style={{ fontSize: "0.75rem", letterSpacing: "0.1em", textTransform: "uppercase" }}
      >
        {children}
      </span>
    </div>
  );
}

const prose = {
  fontSize: "1.05rem",
  lineHeight: 1.8,
  color: "#3a3a4a",
};
